import React, { Component, PropTypes } from "react";
import imagePromise from "image-promise"
import Slider from "react-slick"


export default class HomeSlider extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.string,
      image: PropTypes.string.isRequired,
    })).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {

      items: [
        {
          alt: 'loader',
          image: '',
        }
      ],
      loaded: false,
      mounted: false,
    };
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  componentDidMount() {
    this.setState({ mounted: true });
    const { items } = this.props
    const newItems = []
    const promises = []

    const loadImages = (item, index) => {
      promises.push(imagePromise(item.image).then((img) => {
        newItems[ index ] = { ...item }
      }))
    };
    for (let i in items) {
      loadImages(items[ i ], i)
    }

    Promise.all(promises).then(() => {
      if (this.state.mounted) {
        this.setState({ items: newItems })
        this.setState({ loaded: true })
      }
    }).catch(e => console.log(e))

  }

  render() {
    // eslint-disable-next-line
    let { items, ...props } = this.props;

    return (
      this.state.loaded &&
      <Slider {...props}>
        {this.state.items.map((item, id) =>
          <img key={id} width="100%" alt={item.alt} src={item.image}/>
        )}
      </Slider>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/HomeSlider.js